 export enum FullOrPartialPort {
  SelectOne = "Select One",
  Full = "Full",
  Partial = "Partial",
  
  
}
  
  